<template>
  <div class="basics_example_component" :class="{'three-row': answerSheet.acCardPanes == 3}" v-show="answerSheet.acCardMissSign">
    <div class="correct">
      <span class="text">正确填涂</span>
      <span class="correct_content content"></span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
data() {
  return {
  }
},
computed: {
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
  }
}
</script>

<style lang="scss" scoped>
.basics_example_component{
  width: 100%;
  border-top: 1px solid var(--card-color);
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.correct, .error{
  display: flex;
  align-items: center;
  .text{
  }
  .content{
    margin-left: 10px;
  }
}
.correct{
  padding: 0 15px;
  .correct_content{
    width: 20px;
    height: 8px;
    background-color: #000;
    .text {
      white-space: nowrap;
    }
  }
}
.error{
    margin-left: 14px;

}
.three-row {
  .error, .content {
    margin-left: 3px !important;
  }
  .text {
      white-space: nowrap;
    }
}
</style>